import { render } from "./modal_user.vue?vue&type=template&id=33bde668"
import script from "./modal_user.vue?vue&type=script&lang=js"
export * from "./modal_user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__